import React from "react";
import {
  numbersToWords,
  getMonthName,
  calculateNetSalary,
  currencyFormat,
  getUserRole,
} from "@utils/utils";
import moment from "moment";
import ObjectRender from "../ObjectRender";
import LeaveModule from "./LeaveModule";
import ExemptBySystem from "@components/ExemptBySystem";
import { USER_ROLES } from "@utils/constants";

export class PayrollPrint extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="col-11" style={PayrollWrapper}>
        {this.props.payrollData.map(function (payroll) {
          return (
            <React.Fragment key={payroll._id}>
              <br />
              <h5 style={PayrollHeader}>
                {`Shayan Solutions Payslip for ${getMonthName(
                  new Date(payroll.salary_date).getMonth()
                )} ${new Date(payroll.salary_date).getFullYear()}`}
              </h5>
              <br />
              <br />
              <div className="container">
                <div className="row">
                  <div className="col-6">
                    <h5 style={fieldsLabel}>
                      <b>Emp. Name: </b>
                      {payroll.employee_name}
                    </h5>
                  </div>
                  <div className="col-6">
                    <h5 style={fieldsLabel}>
                      <b>Total Hours: </b>
                      {payroll.no_of_hours}
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <h5 style={fieldsLabel}>
                      <b>Designation: </b>
                      {payroll.job_title}
                    </h5>
                  </div>
                  <div className="col-6">
                    <h5 style={fieldsLabel}>
                      <b>Mode of payment: </b>
                      {payroll.employee?.mode_of_payment
                        ? payroll.employee?.mode_of_payment
                        : "Please Update Mode Of Payment!"}
                    </h5>
                  </div>
                  {payroll.employee?.mode_of_payment === "Bank Transfer" && (
                    <>
                      <div className="col-6">
                        <h5 style={fieldsLabel}>
                          <b>Bank Name: </b>
                          {payroll.employee?.bank_name}
                        </h5>
                      </div>
                      <div className="col-6">
                        <h5 style={fieldsLabel}>
                          <b>Account No: </b>
                          {payroll.employee?.account_No}
                        </h5>
                      </div>
                    </>
                  )}
                </div>
                <div className="row">
                  <div className="col-6">
                    <h5 style={fieldsLabel}>
                      <b>Contract: </b>
                      {payroll.employee.contract}
                    </h5>
                  </div>
                  <div className="col-6">
                    <h5 style={fieldsLabel}>
                      <b>Late Arrivals: </b>
                      {payroll.late_arrivals}
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <h5 style={fieldsLabel}>
                      <b>Joining date: </b>
                      {moment(payroll.employee?.joining_date).format(
                        "DD MMMM YYYY"
                      )}
                    </h5>
                  </div>
                  <div className="col-6">
                    <h5 style={fieldsLabel}>
                      <b>Exemptions: </b>
                      {payroll.exemptions}
                    </h5>
                  </div>
                </div>
                <div className="row">
                  {payroll.employee?.mode_of_payment === "Cheque" ? (
                    <div className="col-6">
                      <h5 style={slipFooter}>
                        Cheque No: __________________________
                      </h5>
                    </div>
                  )
                  :<div className="col-6"></div>
                }
                <ExemptBySystem late_arrivals={payroll?.late_arrivals}/>
                </div>
              </div>
              <br />
              <br />

              <ObjectRender payroll={payroll} />
              <br />
              <br />
              <br />

              <div className="container">
                <div className="row">
                  <div className="col-6" style={finalSalary}>
                    {payroll.deduction_note && (
                      <h5 className="p-1" style={fieldsLabel}>
                        <b>Deduction : </b>
                        {payroll.deduction_note}
                      </h5>
                    )}
                  </div>
                  <div className="col-6"></div>
                </div>
                <div className="row">
                  <div className="col-6" style={finalSalary}>
                    <div className="col-10">
                      <h6>Leaves Summary</h6>
                      <LeaveModule payroll={payroll} />
                    </div>
                  </div>
                  <div className="col-6">
                    <h5 style={notesLabel}>
                      {payroll.notes?.trim() === "" ||
                      getUserRole() != USER_ROLES[0] || getUserRole() != "Admin" ?  (
                        <></>
                      ) : (
                        <div style={NotesDiv}>
                          <b>Note: </b>
                          <div>
                            {payroll?.notes?.length &&
                              payroll.notes
                                .trim()
                                ?.split("\n")
                                .map((item, key) => (
                                  <span style={Notes} key={key}>
                                    &nbsp; {item}
                                    <br />
                                  </span>
                                ))}
                          </div>
                        </div>
                      )}
                    </h5>
                  </div>
                </div>
                <br />

                <br />
                <div className="row">
                  <div className="col-6">
                    <h5 className="p-1" style={fieldsLabel}>
                      <b>Net Pay: </b>
                      {currencyFormat(calculateNetSalary(payroll))}
                    </h5>
                    <h5 className="mt-4" style={slipFooter}>
                      HR Signature: _____________________
                    </h5>
                  </div>
                  <div className="col-6">
                    <h5 className="p-1" style={salaryInWords}>
                      <b>In Words: </b>
                      {/* {" "} added to add space after rupees and before only*/}
                      <span style={Notes}>
                        Rupees {numbersToWords(calculateNetSalary(payroll))}{" "}
                        only
                      </span>
                    </h5>
                    <h5 className="mt-2" style={slipFooter}>
                      Employee Signature: _____________________
                    </h5>
                  </div>
                </div>
                <br />
                <br />
                <br />

                <div
                  className="row"
                  style={{
                    minHeight: "85px",
                  }}
                >
                  <div className="col"></div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

const PayrollWrapper = {
  fontFamily: "Arial, Helvetica, sans-serif",
  padding: "0px 25px 0px 25px",
  margin: "auto",
};

const PayrollHeader = {
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "20px",
  marginTop: "2rem",
};

const fieldsLabel = {
  fontWeight: 500,
  fontSize: "14px",
  textAlign: "left",
};

const finalSalary = {
  display: "flex",
  fontSize: "14px",
};

const salaryInWords = {
  textTransform: "capitalize",
  fontWeight: 500,
  fontSize: "14px",
  textAlign: "left",
};

const slipFooter = {
  fontWeight: "bold",
  fontSize: "14px",
  textAlign: "left",
};

const notesLabel = {
  fontWeight: 500,
  fontSize: "14px",
  textAlign: "left",
  // minHeight: "75px",
};

const Notes = {
  fontWeight: 500,
  fontSize: "12px",
};

const NotesDiv = {
  display: "flex",
};
